var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 16,
    viewBox: "0 0 35 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.0917 8.7071C34.4822 8.31658 34.4822 7.68341 34.0917 7.29289L27.7278 0.92893C27.3372 0.538406 26.7041 0.538406 26.3135 0.92893C25.923 1.31945 25.923 1.95262 26.3135 2.34314L31.9704 8L26.3135 13.6569C25.923 14.0474 25.923 14.6805 26.3135 15.0711C26.7041 15.4616 27.3372 15.4616 27.7278 15.0711L34.0917 8.7071ZM1.04235e-07 9L33.3846 9L33.3846 7L-1.04235e-07 7L1.04235e-07 9Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.080f06419baa377bff24d2724cbb8cf1.svg";
export { ForwardRef as ReactComponent };